/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStorefrontReminders200ResponseInner
 */
export interface GetStorefrontReminders200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontReminders200ResponseInner
     */
    type: GetStorefrontReminders200ResponseInnerTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontReminders200ResponseInner
     */
    smsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontReminders200ResponseInner
     */
    emailEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetStorefrontReminders200ResponseInner
     */
    whatsappEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontReminders200ResponseInner
     */
    customText?: string;
}


/**
 * @export
 */
export const GetStorefrontReminders200ResponseInnerTypeEnum = {
    Confirmation: 'confirmation',
    Delivery: 'delivery',
    ReadyToPickup: 'ready_to_pickup',
    Reviews: 'reviews'
} as const;
export type GetStorefrontReminders200ResponseInnerTypeEnum = typeof GetStorefrontReminders200ResponseInnerTypeEnum[keyof typeof GetStorefrontReminders200ResponseInnerTypeEnum];


/**
 * Check if a given object implements the GetStorefrontReminders200ResponseInner interface.
 */
export function instanceOfGetStorefrontReminders200ResponseInner(value: object): value is GetStorefrontReminders200ResponseInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('smsEnabled' in value) || value['smsEnabled'] === undefined) return false;
    if (!('emailEnabled' in value) || value['emailEnabled'] === undefined) return false;
    if (!('whatsappEnabled' in value) || value['whatsappEnabled'] === undefined) return false;
    return true;
}

export function GetStorefrontReminders200ResponseInnerFromJSON(json: any): GetStorefrontReminders200ResponseInner {
    return GetStorefrontReminders200ResponseInnerFromJSONTyped(json, false);
}

export function GetStorefrontReminders200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontReminders200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'smsEnabled': json['smsEnabled'],
        'emailEnabled': json['emailEnabled'],
        'whatsappEnabled': json['whatsappEnabled'],
        'customText': json['customText'] == null ? undefined : json['customText'],
    };
}

export function GetStorefrontReminders200ResponseInnerToJSON(json: any): GetStorefrontReminders200ResponseInner {
    return GetStorefrontReminders200ResponseInnerToJSONTyped(json, false);
}

export function GetStorefrontReminders200ResponseInnerToJSONTyped(value?: GetStorefrontReminders200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'smsEnabled': value['smsEnabled'],
        'emailEnabled': value['emailEnabled'],
        'whatsappEnabled': value['whatsappEnabled'],
        'customText': value['customText'],
    };
}

